/**
 * Retrieves the ID of a logged-in customer from various possible sources.
 * @ref https://community.shopify.com/c/shopify-apis-and-sdks/current-best-way-to-get-logged-in-customer-id/td-p/482773
 * @returns {string|null} The ID of the logged-in customer, or null if not found.
 */
export const getCustomerId = () => {
  return (
    window?.__st?.cid ||
    window.meta?.page?.customerId ||
    window.ShopifyAnalytics?.meta?.page?.customerId
  );
};
